import * as React from "react";
import {cx} from "emotion";

import "./step-4-cass-result.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {IntervalReload} from "@Common/react/interval-reload";
import {UseState}       from "@Common/react/use-state";

import {ConfirmDialog} from "../../../../../common/design2/dialogs/confirm-dialog/confirm-dialog";
import {Header}        from "../../common/header/header";

import {ListView} from "./list-view/list-view";
import {Overview} from "./overview/overview";

export const Step4CassResult = ({entityId, next}) => cs(
    ["mailingListId", (_, next) => UseState({next})],
    ["listName", (_, next) => UseState({next})],
    ({mailingListId, listName}) => next({
        ready: listName.value,
        acceptMailingListId: mailingListId.onChange,
        acceptListName: listName.onChange,
        render: ({onClose}) => cs(
            consumeContext("apis"),
            ["cass", ({apis}, next) => IntervalReload({
                fetch: () => apis.next.mailing.getCass(mailingListId.value),
                continueCondition: (cass) => cass.status !== "complete",
                next,
            })],
            ["confirmDialog", (_, next) => ConfirmDialog({next})],
            ({cass, confirmDialog}, next) => (
                <div className="step-4-cass-result-7xx">
                    {Header({
                        icon: require("../../../../mailing-icons/listtype-condo.png"),
                        title: "CASS Result",
                        subTitle: "We have processed your list against US Postal Service data and identified invalid addresses",
                    })}

                    <div className="content">
                        {next()}
                    </div>

                    <div className="footer">
                        <button {...{
                            className: cx("next", {disabled: cass.value?.status !== "complete"}),
                            "xd-qa-type": "button",
                            "xd-qa-name": "CASS Result Close",
                            onClick: async () => {
                                if (cass.value?.status !== "complete") {

                                    if (await confirmDialog.show({
                                        message: "Address verification is in progress, if you close now some mail addresses may be invalid",
                                        actionName: "close",
                                    })) {
                                        onClose(mailingListId.value);
                                    }
                                } else {
                                    onClose(mailingListId.value);
                                }
                            },
                        }}>
                            Close
                        </button>
                    </div>
                </div>
            ),
            ["viewList", (_, next) => UseState({
                next,
            })],
            ({viewList, cass}) => !viewList.value ? (
                Overview({
                    fileName: listName.value,
                    onViewList: () => viewList.onChange(true),
                    cass: cass.value,
                })
            ) : (
                ListView({mailingListId: mailingListId.valueentity, entityId})
            ),
        )
    })
);